export enum ErrorPath {
  error = 'error',
  notfound = 'notfound',
}
